function removeEmptyProductBlocks(root = document) {
  root.querySelectorAll(".product-block").forEach(function (el) {
    const hasText = el.textContent.trim().length > 0;
    const hasImportantChildren = el.querySelector(
      "img, video, iframe, svg, canvas, input, select, textarea, button, a, hr, audio, object, embed, picture, source, track, map, area, details, summary, meter, progress",
    );

    if (!hasText && !hasImportantChildren) {
      el.remove();
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  removeEmptyProductBlocks();
});

document.addEventListener("shopify:section:load", function (event) {
  removeEmptyProductBlocks(event.target);
});
